export const environment = {
  production: true,


  /**Dev Envirnoment */
  server_url: 'https://angacc.iagility.com',// Main app URL BE.
  angular_url: 'https://client.iagility.com',//FE URLS for redirection
  account_url: 'https://account.iagility.com',//FE URLS for redirection
  admin_url: 'https://admin.iagility.com',// FE URLS for redirection
  consultant_url: 'https://consultant.iagility.com',// FE URLS for redirection
  client_url: 'https://client.iagility.com',// FE URLS for redirection
  main_url: 'https://iagility.com/' // Main app URL BE./ 

  
/** Local Environment */
  // server_url: 'https://accountdevtest.iagility.com',// Main app URL BE.
  // angular_url: 'https://localhost:4500',//FE URLS for redirection
  // account_url: 'https://localhost:4500',//FE URLS for redirection
  // admin_url: 'https://localhost:4100',// FE URLS for redirection
  // consultant_url: 'https://localhost:4300',// FE URLS for redirection
  // client_url: 'https://localhost:4400',// FE URLS for redirection
  // main_url: 'https://accountdevtest.iagility.com' // Main app URL BE./ 
};